import React, { useState } from "react";
import { Form, Row, Col, Button, Container, FloatingLabel } from "react-bootstrap";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";


const API_URL = process.env.REACT_APP_API_URL;

function Add_data_entry() {
    const [data_heading, setData_heading] = useState("");
    const [data_body, setData_body] = useState("");
    const [comment, setComment] = useState("");
    const [documents, setDocuments] = useState([{ id: Date.now(), name: "", file: null }]);
    const navigate = useNavigate();

    const addRow = () => {
        setDocuments([...documents, { id: Date.now(), name: "", file: null }]);
    };

    const removeRow = (id) => {
        if (documents.length === 1) return;
        setDocuments(documents.filter((doc) => doc.id !== id));
    };

    const handleNameChange = (id, value) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, name: value } : doc))
        );
    };

    const handleFileChange = (id, file) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, file: file } : doc))
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("data_heading", data_heading);
        formData.append("data_body", data_body);
        formData.append("comment", comment);

        documents.forEach((doc, index) => {
            formData.append(`document_name[${index}]`, doc.name);
            if (doc.file) formData.append(`document_file[${index}]`, doc.file);
        });

        try {
            const res = await axios.post(`${API_URL}/add_data_entry`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            alert(res.data.message);
            navigate("/List_data_entry");

            setData_heading("");
            setData_body("");
            setComment("");
            setDocuments([{ id: Date.now(), name: "", file: null }]);
        } catch (error) {
            console.error(error);
            alert("Error adding data!");
        }
    };

    return (
        <>
            <Container className="mt-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="m-0">Add New Data</h3>
                    <Link className="btn btn-sm btn-primary" to="/List_data_entry">
                        List
                    </Link>
                </div>

                <Form onSubmit={handleSubmit} autoComplete="off">

                    <Row className="gy-3">
                        <Col xs={12}>
                            <FloatingLabel controlId="floatingHeading" label="Enter Heading">
                                <Form.Control
                                    type="text"
                                    value={data_heading}
                                    onChange={(e) => setData_heading(e.target.value)}
                                    placeholder="Enter heading"
                                    style={{ backgroundColor: "#d6f5f5" }}
                                />
                            </FloatingLabel>
                        </Col>

                        <Col xs={12}>
                            <FloatingLabel controlId="floatingBody" label="Enter Details">
                                <Form.Control
                                    as="textarea"
                                    value={data_body}
                                    onChange={(e) => setData_body(e.target.value)}
                                    placeholder="Enter details"
                                    style={{
                                        height: "100px",
                                        backgroundColor: "#99e6e6"
                                    }}
                                />
                            </FloatingLabel>
                        </Col>

                        <Col xs={12}>
                            <FloatingLabel controlId="floatingComment" label="Enter Comments">
                                <Form.Control
                                    as="textarea"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                    placeholder="Enter comments"
                                    style={{ height: "60px" }}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col xs={12}>
                            <table className="table table-bordered table-responsive">
                                <thead>
                                    <tr style={{ backgroundColor: "#e6ffff", fontWeight: "bold" }}>
                                        <th>Sr.No</th>
                                        <th>Document Name</th>
                                        <th>Select Document</th>
                                        <th>
                                            <i
                                                className="bi bi-plus"
                                                style={{ cursor: "pointer", fontSize: "1.2rem" }}
                                                onClick={addRow}
                                            ></i>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {documents.map((doc, index) => (
                                        <tr key={doc.id}>
                                            <td>{index + 1}</td>

                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    value={doc.name}
                                                    onChange={(e) =>
                                                        handleNameChange(doc.id, e.target.value)
                                                    }
                                                    placeholder="Enter document name"
                                                />
                                            </td>

                                            <td>
                                                <Form.Control
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png,.pdf,.svg"
                                                    onChange={(e) =>
                                                        handleFileChange(doc.id, e.target.files[0])
                                                    }
                                                />
                                            </td>

                                            <td>
                                                <i
                                                    className="bi bi-trash"
                                                    style={{ cursor: "pointer", color: "red" }}
                                                    onClick={() => removeRow(doc.id)}
                                                ></i>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>

                    <Row className="mt-3">
                        <Col xs={12} className="d-flex justify-content-center">
                            <Button variant="primary" type="submit">
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Container>
        </>
    );

}

export default Add_data_entry;
